var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 330 330",
    viewBox: "0 0 330 330",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.059 16h-32.118c-2.717 0-4.941 2.282-4.941 5s2.224 5 4.941 5h32.118c2.717 0 4.941-2.282 4.941-5s-2.224-5-4.941-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m281.63 48.328c-31.164-31.165-72.599-48.328-116.67-48.328s-85.508 17.163-116.67 48.328c-64.333 64.334-64.333 169.01 0 233.34 31.164 31.164 72.599 48.327 116.67 48.327 44.073 0 85.507-17.163 116.67-48.328 31.165-31.164 48.328-72.599 48.328-116.67s-17.163-85.508-48.328-116.67zm-21.213 212.13c-25.498 25.497-59.399 39.54-95.458 39.54-36.06 0-69.961-14.043-95.46-39.54-52.636-52.637-52.636-138.28 0-190.92 25.498-25.499 59.399-39.541 95.459-39.541s69.961 14.042 95.459 39.54c25.498 25.499 39.541 59.4 39.541 95.46s-14.043 69.961-39.541 95.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m254.96 150h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.05a88f96.svg";
export { ForwardRef as ReactComponent };